import React, { Component } from "react";
import "./App.css";
import Title from "./component/title";
import Form from "./component/form";
import Weather from "./component/weather";
import Parallax from "./component/parallax";
import Logo from "./component/images/weather-guage.png";

const API_KEY = "141e4ea94f8ceec00576decc779d0f6a";

class App extends Component {
  state = {
    temperature: undefined,
    city: undefined,
    country: undefined,
    humdity: undefined,
    description: undefined,
    error: undefined
  };

  getWeather = async e => {
    e.preventDefault();
    const city = e.target.elements.city.value;
    const country = e.target.elements.country.value;
    const api_call = await fetch(
      `https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&units=metric&APPID=${API_KEY}`
    );
    const data = await api_call.json();
    if (city && country) {
      console.log(data);
      this.setState({
        temperature: data.main.temp,
        city: data.name,
        country: data.sys.country,
        humidity: data.main.humidity,
        description: data.weather[0].description,
        error: ""
      });
    } else {
      this.setState({
        temperature: undefined,
        city: undefined,
        country: undefined,
        humidity: undefined,
        description: undefined,
        error: "Please enter the values"
      });
    }
  };
  render() {
    return (
      <div className="App center grey">
        <div className="navbar-fixed">
          <nav className="white">
            <ul>
              <li>
                <p className="the-logo">
                  <img src={Logo} class="responsive-img" />
                </p>
              </li>
            </ul>
          </nav>
        </div>

        <div className="row">
          <div className=" col s1 m2 l3 " />
          <div className=" col s10 m8 l6">
            <p className="btn">
              You can check the weather of anywhere in a click!
            </p>
            <Title />
            <Form getWeather={this.getWeather} />
            <Weather
              temperature={this.state.temperature}
              city={this.state.city}
              country={this.state.country}
              humidity={this.state.humidity}
              description={this.state.description}
              error={this.state.error}
            />
          </div>
          <div className=" col s1 m2 l3 " />
        </div>
        <Parallax />
        <footer>
          <p>Created with React and Materialize Css By Daniel Don</p>
          <p className="btn">
            <a
              href="https://chiagozielam.github.io"
              target="_blank"
              className="white-text"
            >
              View Portfolio
            </a>
          </p>
        </footer>
      </div>
    );
  }
}

export default App;
